import axios from 'axios';

const API_DOMAIN = window.__RUNTIME_CONFIG__.REACT_APP_API_DOMAIN || 'http://localhost:3001';

export interface SlackConversationDay {
  date: string;
  messages: SlackMessage[];
  channelName: string;
  participants: SlackParticipant[];
}

export interface SlackMessage {
  ts: string;
  threadId?: string;
  userId?: string;
  userName?: string;
  userInfo?: SlackUserInfo;
  text: string;
  timestamp: string;
  createdAt?: string;
  updatedAt?: string;
  mentionedUsers?: SlackUserInfo[] | null;
  link?: string;
  replies?: SlackMessage[];
  isThreadParent?: boolean;
  replyCount?: number;
  latestReplyTs?: string;
  reactions?: Array<{ name: string; count: number; users?: string[] }>;
  edited?: { user: string; ts: string } | null;
}

export interface SlackUserInfo {
  id: string;
  name?: string;
  realName?: string | null;
  displayName?: string | null;
  email?: string;
  isBot?: boolean;
  isAppUser?: boolean;
}

export interface SlackParticipant {
  userId: string;
  displayName?: string;
  email?: string;
  messageCount: number;
  affiliation?: 'internal' | 'external';
}

export interface SlackConversationResponse {
  days: SlackConversationDay[];
  hasMoreBefore: boolean;
  hasMoreAfter: boolean;
  earliestDate: string | null;
  latestDate: string | null;
}

export interface FetchSlackConversationParams {
  channelId: string;
  startDate: string;
  endDate: string;
  cutMode?: 'day' | 'thread';
}

export const fetchSlackConversation = async (
  params: FetchSlackConversationParams,
  auth0: { getAccessTokenSilently: () => Promise<string> }
): Promise<SlackConversationResponse> => {
  const { channelId, startDate, endDate, cutMode } = params;
  const url = `${API_DOMAIN}/cx-items/slack/${encodeURIComponent(channelId)}/conversation`;
  const response = await axios.get<SlackConversationResponse>(url, {
    params: { startDate, endDate, ...(cutMode && { cutMode }) },
  });
  return response.data;
};
